import { z } from 'zod';
import { ErrorResponseSchema } from '@/schemas/common/base';

/**
 * Mark sold parameter schema
 * Validates the listing ID from the URL path
 */
export const MarkSoldParamSchema = z.object({
  id: z.string().refine(val => !isNaN(parseInt(val, 10)), 'Invalid listing ID'),
});

export type MarkSoldParam = z.infer<typeof MarkSoldParamSchema>;

/**
 * Mark sold success response schema
 */
export const MarkSoldSuccessResponseSchema = z.object({
  success: z.literal(true),
  listing: z.object({
    id: z.number(),
    status: z.number(),
  }),
});

export type MarkSoldSuccessResponse = z.infer<typeof MarkSoldSuccessResponseSchema>;

/**
 * Mark sold response schema (success or error)
 */
export const MarkSoldResponseSchema = z.discriminatedUnion('success', [
  MarkSoldSuccessResponseSchema,
  ErrorResponseSchema,
]);

export type MarkSoldResponse = z.infer<typeof MarkSoldResponseSchema>;
